<template>
    <div class="anchor-box">
        <ul class="anchor-list">
            <li
                class="anchor-item"
                :class="{ selected: item.id === selectId }"
                v-for="item in anchorData"
                :key="item.id"
                :data-id="item.id"
                @click="scrollToModuleById(item.id)"
            >
                <span class="text">{{ item.label }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import global from '@/common/global';
import util from '@/common/util';
//  anchor navigation bar ， What needs to be displayed at the anchor point can be added here
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    data: function() {
        return {
            selectId: ''
        };
    },
    computed: {
        ANCHOR_OPTIONS() {
            return [
                {
                    name: 'md-sold-detail',
                    text: this.$t('md-sold-detail.keyDetail')
                },
                {
                    name: 'md-sold-estimate',
                    text: this.$t('md-sold-detail.estimatePrice')
                },
                {
                    name: 'md-map',
                    text: this.$t('md-sold-detail.schools')
                },
                {
                    name: 'md-market-trends',
                    text: this.$t('md-sold-detail.marketTrend')
                },
                {
                    name: 'md-listing-list',
                    text: this.$t('md-sold-detail.recentSold')
                },
                {
                    name: 'md-house-listing',
                    text: this.$t('md-sold-detail.similarHomes')
                },
                {
                    name: 'md-house-facts',
                    text: this.$t('md-sold-detail.facts')
                }
            ];
        },
        anchorData() {
            const moduleData = this.$root.moduleData;
            const data = [];
            //  Find out the modules that need anchor points
            for (let module of moduleData) {
                let opt = this.ANCHOR_OPTIONS.find(a => a.name === module.name);
                if (!opt) {
                    continue; 
                }
                if (
                    !module.moduleMounted ||
                    (module.moduleMounted && module.moduleRender)
                ) {
                    data.push({
                        label: opt.text,
                        id: module.id
                    });
                }
            }
            return data;
        }
    },
    mounted() {
        global.scroll(this.onScroll);
    },
    methods: {
        scrollToTarget(el) {
            const container = document.documentElement;
            if (!container) {
                return; 
            }

            let top = el.offsetTop - window.innerHeight / 2 + 30;
            let scrollOptions = { top, left: 0, behavior: 'smooth' };

            if (window.self !== window.top && util.isIphone) {
                const iOSVersion = /OS (\d+)/.exec(navigator.userAgent);
                if (iOSVersion.length > 1) {
                    const versionNumber = parseInt(iOSVersion[1], 10);
                    if (versionNumber === 15) {
                        delete scrollOptions.behavior;
                    }
                }
            }

            container.scrollTo(scrollOptions);
        },
        scrollToModuleById(id) {
            let module = this.$root.getModuleById(id);
            if (module) {
                // 30 The offset is to ensure that the module is displayed in the middle of the screen

                if (module.$el) {
                    // main.page-content is the scroll container
                    this.scrollToTarget(module.$el);
                } else {
                    module.$nextTick(() => {
                        this.scrollToTarget(module.$el);
                    });
                }
            } else {
                console.log('Exception: This module is not exitable!');
            }
        },
        onScroll() {
            //  Which module is the center of the viewport ， which anchor point to switch to
            for (let a of this.anchorData) {
                let vm = this.$root.getModuleById(a.id);
                if (!vm) {
                    return; 
                }
                if (util.isOnView(vm.$el)) {
                    let nextAnchorEle = this.$el.querySelector(
                        `[data-id="${a.id}"]`
                    );
                    if (nextAnchorEle) {
                        let x = nextAnchorEle.getBoundingClientRect().x;
                        let width = nextAnchorEle.getBoundingClientRect().width;
                        let scrollEle = this.$el; // The scroll bar element of the anchor navigation bar
                        //  When the anchor button goes beyond the screen
                        if (x < 0) {
                            //  make the anchor visible
                            scrollEle.scrollBy({
                                top: 0,
                                left: x - 15,
                                behavior: 'smooth'
                            });
                        } else if (x + width > window.innerWidth) {
                            scrollEle.scrollBy({
                                top: 0,
                                left: x + width - window.innerWidth + 15,
                                behavior: 'smooth'
                            });
                        }
                    }
                    this.selectId = a.id;
                }
            }
        }
    },
    beforeUnmount() {
        global.scroll(this.onScroll, true);
    }
};
</script>

<style lang="scss">
.anchor-box {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar {
        display: none;
    }
    .anchor-list {
        padding: 0 15px;
        font-size: 14px;
        white-space: nowrap;
    }
    .anchor-item {
        margin-right: 20px;
        padding: 12px 0;
        display: inline-block;
        transition: all 0.3s ease;
        &.selected {
            position: relative;
            &:after {
                content: '';
                width: 100%;
                height: 3px;
                background-color: #4c84ff;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
        .text {
            white-space: nowrap;
        }
    }
}
.md-sold-detail {
    &.fashion {
        .anchor-box {
            background-color: #2f374f;
            .anchor-item {
                color: #8195bd;
                &.selected {
                    color: #fff;
                    font-family: var(--font-bold);
                    &:after {
                        background-color: var(--color-theme);
                    }
                }
            }
        }
    }
    &.classic {
        .anchor-box {
            background-color: #f2f2f2;
            .anchor-item {
                color: #a8a8a8;
                &.selected {
                    color: #202437;
                    font-family: var(--font-bold);
                    &:after {
                        background-color: var(--color-theme);
                    }
                }
            }
        }
    }
    &.standard {
        .anchor-box {
            background-color: #313b52;
            .anchor-item {
                color: #9c9fa9;
                &.selected {
                    color: #ffffff;
                    font-family: var(--font-bold);
                    &:after {
                        border-radius: 2px;
                        background-color: var(--color-theme);
                    }
                }
            }
        }
    }
}
</style>
